import React from 'react';
import PropTypes from 'prop-types';

const Eye = ({ color = '#8C949C' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Svg-Icons/18px-(All-icons)/UI/show"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <path
                d="M9,4 C5.3813008,4 2.14714478,5.94534075 0,9 C2.14714478,12.0548536 5.3813008,14 9,14 C12.6185072,14 15.8528552,12.0548536 18,9 C15.8528552,5.94534075 12.6185072,4 9,4 Z M9.00019198,12.2717801 C7.21551228,12.2717801 5.76853175,10.8071376 5.76853175,9 C5.76853175,7.19286242 7.21551228,5.72821988 9.00019198,5.72821988 C10.7848717,5.72821988 12.2310843,7.19286242 12.2310843,9 C12.2310843,10.8071376 10.7848717,12.2717801 9.00019198,12.2717801 Z M9,6.68572873 C7.73770772,6.68572873 6.71424305,7.72196089 6.71424305,9 C6.71424305,10.2782335 7.73770772,11.3142713 9,11.3142713 C10.2624843,11.3142713 11.2857569,10.2782335 11.2857569,9 C11.2857569,7.72196089 10.2624843,6.68572873 9,6.68572873 Z"
                id="Shape"
                fill={color}
            />
        </g>
    </svg>
);

Eye.propTypes = {
    color: PropTypes.string,
};

export default Eye;
